import React from 'react'
import { css, cx } from '@emotion/css'
import { theme } from '@contrast-security-inc/design-system-foundations'
import { FormattedMessage, MessageDescriptor } from 'react-intl'
import { Props as IntlProps } from 'react-intl/src/components/message'
import { CsCloseIcon } from '../../legacy-design-system/icons'
import {
  drilldownPageTitleCss,
  panelTitleCss
} from '../../legacy-design-system/text'

interface Props {
  readonly onClose?: () => void
  readonly title: MessageDescriptor
  readonly subtitle: IntlProps
  readonly children: React.ReactNode | React.ReactNode[]
}

const mainContainerCss = css`
  width: 500px;
  background-color: ${theme.color.white};
  border-radius: 5px;
`

const headerContainerCss = css`
  padding: 22px 0px 0px 25px;
  margin-bottom: 15px;
  text-align: left;
`

const closeIconContainerCss = css`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-right: 30px;
  margin-top: 8px;
`

const closeIconCss = css`
  height: 13px;
  width: 13px;
  color: ${theme.color.neutral40};
`

const titleContainerCss = css`
  display: flex;
  padding: 4px 4px 4px 0px;
`

const titleCss = css`
  flex: 1 1 auto;
  padding-bottom: 0px;
  margin-bottom: 0px;
  font-size: 15px;
`

const subTitleCss = css`
  padding-bottom: 0px;
  margin-bottom: 0px;
  margin-top: -5px;
`

export function OnboardingPanelContent({
  title,
  subtitle,
  onClose,
  children
}: Props) {
  return (
    <div className={mainContainerCss}>
      <div className={headerContainerCss}>
        <div className={titleContainerCss}>
          <FormattedMessage {...title}>
            {(text) => (
              <span className={cx(panelTitleCss, titleCss)} children={text} />
            )}
          </FormattedMessage>
          <span className={closeIconContainerCss}>
            <CsCloseIcon onClick={onClose} size={12} className={closeIconCss} />
          </span>
        </div>
        <p
          className={cx(drilldownPageTitleCss, subTitleCss)}
          children={<FormattedMessage {...subtitle} />}
        />
      </div>
      {<div>{children}</div>}
    </div>
  )
}
